import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import List from '../../components/Crud/List';
import { useAuth } from '../../contexts/auth';

export type ReminderModel = {
  id: number;
  description: string;
  isActive: boolean;
  isRequired: boolean;
};

export default function RemindersIndex() {
  const [isLoading, setIsLoading] = useState(true);
  const [reminders, setReminders] = useState([] as ReminderModel[]);

  const {
    user: { organization },
  } = useAuth();

  async function getReminders() {
    if (organization) {
      setIsLoading(true);
      const response = await api.get(
        `organizations/${organization.id}/reminders`
      );
      setReminders(response.data.data);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getReminders();
  }, [organization]);

  return (
    <List isLoading={isLoading} title='Lembretes' newItemUrl='new'>
      <table className='table table-hover'>
        <thead>
          <tr>
            <th scope='col'>#</th>
            <th scope='col'>Nome</th>
            <th scope='col'>Ativo?</th>
          </tr>
        </thead>
        <tbody>
          {reminders.map((i) => {
            return (
              <tr key={i.id}>
                <td>{i.id}</td>
                <td>
                  <Link to={`/reminders/${i.id}/edit`}>{i.description}</Link>
                </td>
                <td>{i.isActive ? 'Sim' : 'Não'}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </List>
  );
}
